import MaldivesCharterCarousel from 'home/components/OfferCarousels/MaldivesCharterCarousel'
import { useIntl } from 'react-intl'

function LoyaltyRewardsOfferCarouselSection() {
  const intl = useIntl()

  const title = intl.formatMessage({
    id: 'REZS0nshCyUpWdTj0WXy',
    defaultMessage: 'Top Maldives bundles with Société Rewards',
    description: 'Heading for the Maldives charter offer carousel on the Société Rewards page',
  })

  // Keep the carousel shell on the Société page while offers load (or if the list is briefly empty).
  return <MaldivesCharterCarousel
    overrideTitle={title}
    useRewardPreviewPricing
    hideWhenEmpty={false}
    includeBundleStream={false}
  />
}

export default LoyaltyRewardsOfferCarouselSection
